import React, { useRef } from "react"
import { useGLTF } from "@react-three/drei"
import { isMobile } from "react-device-detect"
import { hydrate } from "react-dom"

export default function Model(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF("/dice-down1.glb")
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        geometry={nodes.Blank_Dice.geometry}
        material={nodes.Blank_Dice.material}
        scale={[0.53, 0.53, 0.53]}
      >
        {isMobile ? (
          <meshStandardMaterial color="white" roughness={0.3} />
        ) : (
          <meshPhysicalMaterial
            roughness={0.3}
            clearcoat={1}
            clearcoatRoughness={0.2}
            color={"white"}
          />
        )}
      </mesh>
    </group>
  )
}

useGLTF.preload("/dice-down1.glb")
